module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"importance":"Bedeutung","audititem":"Auditfrage","category":"Kategorie","chapter":"Kapitel","create_item":"Frage erstellen","use_template":"Vorlage nutzen"},"en":{"importance":"Importance","audititem":"Auditquestion","category":"Category","chapter":"Chapter","create_item":"Create Question","use_template":"Use Template"}}')
  delete Component.options._Ctor
}
